import api from './api';

// 邀请码服务
export const invitationCodeService = {
  // 创建邀请码
  create: async (data, username) => {
    try {
      const response = await api.post(`/api/invitation-codes?username=${username}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 分页查询邀请码
  queryByPage: async (params) => {
    try {
      const response = await api.post('/api/invitation-codes/query', params);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 删除邀请码
  deleteById: async (id, username) => {
    try {
      const response = await api.delete(`/api/invitation-codes/${id}?username=${username}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 验证邀请码
  validate: async (code) => {
    try {
      const response = await api.post('/api/invitation-codes/validate', { code });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 使用邀请码
  use: async (code, userId) => {
    try {
      const response = await api.post('/api/invitation-codes/use', { code, userId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 获取邀请码统计信息
  getStatistics: async (username) => {
    try {
      const response = await api.get(`/api/invitation-codes/statistics?username=${username}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};